import Vue from 'vue';

export default class BodyMounter {
  mount (renderFn) {
    this.node = document.createElement('div');
    const mountingNode = this.node.appendChild(document.createElement('div'));
    document.body.appendChild(this.node);
    this.vm = new Vue({
      name: 'BodyMounter',
      render (h) {
        return renderFn(h);
      },
    }).$mount(mountingNode);
    return this.vm;
  }

  destroy () {
    this.vm.$destroy();
    this.node.parentNode.removeChild(this.node);
  }
}
